/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './MarkDuplicateForm.css';

import {
  getDupeSuggestions,
} from '../../actions';


class MarkDuplicateForm extends OzFormComponent {

  static fields = [
    'roomIds',
  ];

  constructor(props) {
    super(props);
    this.state.dupeIdsDict = {};
  }
  
  componentDidMount() {
    let room = this.props.room;
    this.props.getDupeSuggestions(null, {}, { room: room.id });
  }

  getValues() {
    let roomIds = Object.keys(this.state.dupeIdsDict);
    roomIds.push(this.props.room.id);
    return { roomIds };
  }

  toggle(id) {
    let dupeIdsDict = Object.assign({}, this.state.dupeIdsDict);
    dupeIdsDict[id] = !dupeIdsDict[id];
    this.setState({ dupeIdsDict })
  }

  renderBody() {
    let room = this.props.room;

    let dupeNodes = [];
    let dupeSuggestions = this.props.dupeSuggestions;
    if (dupeSuggestions) {
      dupeNodes = dupeSuggestions.items.map(ds => {
        if (ds.id == room.id) return null;
        let checked = !!this.state.dupeIdsDict[ds.id];
        return (
          <div key={ds.id}>
            <Checkbox checked={checked} onClick={() => this.toggle(ds.id)}> <b>{ds.name}</b>, {ds.location.company}</Checkbox>
          </div>
        );
      });
    }

    return (
      <div className="MarkDuplicateForm">
        <p>Marking <b>{room.name}, id {room.id}</b> as a dupe.</p>
        <p>Select the rooms that are duplicates to be merged:</p>
        <div>
          {dupeNodes}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dupeSuggestions: state.get.dupeSuggestions,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getDupeSuggestions,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MarkDuplicateForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/MarkDuplicateForm.js
 **/